import { Component, h } from '@stencil/core';

/**
 * @description Puts hidden text on the screen that only a screen reader will see.
 * This component mimics the bootstrap sr-only class for accessibility purposes.
 * @use
 * @since 4.0.0
 * @slot - `default slot`: The hidden text accessible to screen readers.
 * @ssh
 * @version NV
 */
@Component({
  tag: 'hp6-screen-reader-only',
  styleUrl: 'screen-reader-only.scss',
  shadow: false, // Already satisfies the single-tag policy without shadow DOM
})
export class ScreenReaderOnly {
  render() {
    return <slot />;
  }
}
